import { useMemo } from 'react';

import { AnswerReveal, StandardPatternBody } from '@quizzach/components';
import { IQuestion } from '@quizzach/interfaces';
import { analyzeEstimationQuestion, patternAnswerHtml } from '@quizzach/utils';
import { QuestionText, QuestionContainer } from '@quizzach/play-styles';

interface IEstimationQuestionProps {
	color: string;
	currentQuestion: IQuestion;
}

interface IEstimationQuestionAnswerProps {
	questionContainerColor: string;
	answerContainerColor: string;
	currentQuestion: IQuestion;
	hideQuestion?: boolean;
}

export const EstimationQuestionMobile = (props: IEstimationQuestionProps) => {
	const { color, currentQuestion } = props;
	const analysis = useMemo(
		() => analyzeEstimationQuestion(currentQuestion),
		[currentQuestion]
	);

	return analysis.pattern || analysis.note || analysis.kicker ? (
		<StandardPatternBody analysis={analysis} color={color} />
	) : (
		<QuestionContainer color={color}>
			<QuestionText
				dangerouslySetInnerHTML={{ __html: analysis.questionHtml }}
			/>
		</QuestionContainer>
	);
};

export const EstimationQuestionAnswerMobile = (
	props: IEstimationQuestionAnswerProps
) => {
	const { questionContainerColor, currentQuestion, hideQuestion } = props;
	const analysis = useMemo(
		() => analyzeEstimationQuestion(currentQuestion),
		[currentQuestion]
	);

	return (
		<>
			{!hideQuestion &&
			(analysis.pattern || analysis.note || analysis.kicker) ? (
				<StandardPatternBody
					analysis={analysis}
					color={questionContainerColor}
					dim
				/>
			) : (
				<QuestionContainer color={questionContainerColor}>
					{!hideQuestion && (
						<QuestionText
							$small
							dangerouslySetInnerHTML={{ __html: analysis.questionHtml }}
						/>
					)}
				</QuestionContainer>
			)}
			<AnswerReveal
				revealKey={currentQuestion.uuid}
				answerHtml={patternAnswerHtml(
					analysis.pattern,
					currentQuestion.estimation_question?.answer || ''
				)}
				explanation={currentQuestion.estimation_question?.explanation}
			/>
		</>
	);
};
